import { restApi } from '../../../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { paginate } from '../../../../lib/loopback'
import { createQueryString } from '../../../../utils/Repository'

const queryTransform = {
  ...paginate
}

export const validacaoSerproRepository = createRepository({
  path: 'validacao-facial',
  restApi,
  queryTransform: {
    ...paginate
  }
})

validacaoSerproRepository.manualFetch = ({
  solicitacaoId,
  cpf,
  numRegistro,
  numSeguranca,
  nome,
  nomeMae
}) =>
  restApi.post(`/validacao-facial/manual-fetch/${solicitacaoId}`, {
    cpf,
    numRegistro,
    numSeguranca,
    nome,
    nomeMae
  })

validacaoSerproRepository.list = ({ query, paginate, options } = {}) => {
  const queryString = createQueryString(query, paginate, queryTransform)
  return restApi.get('/validacao-facial' + queryString, {}, options)
}

const termoEPoliticaRepository = {
  verificar: ({ cpf }) =>
    restApi.get(`/termo-politica/verificar`, {
      motoristaCpf: String(cpf)
    }),
  criar: ({ cpf, canalEnvio }) =>
    restApi.post(`/termo-politica/criar`, {
      motoristaCpf: String(cpf),
      canalEnvio
    }),
  reenviar: ({ termoId }) => {
    return restApi.put(`/termo-politica/reenviar`, {
      termoId
    })
  }
}
export default termoEPoliticaRepository
